// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QmFg","col":"styles_col__2PcGm"};